import axios from '../../../../utills/axiosConfig';

export const fetchStoneTypes = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/stone-types', { params });
  return res.data;
};

export const addStoneType = async (stoneType) => {
  try {
    const res = await axios.post('/stone-types', stoneType);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateStoneType = async (id, stoneType) => {
  const res = await axios.put(`/stone-types/${id}`, stoneType);
  return res.data;
};

export const deleteStoneType = async (id) => {
  const res = await axios.delete(`/stone-types/${id}`);
  return res.data;
};

export const importStoneTypeCSV = async (formData) => {
  const { data } = await axios.post('/stone-types/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 